import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { euro, dt, PAYMENT_LABELS } from "@/lib/format";
import { PageHeader, Loading, StatusBadge, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Repeat } from "lucide-react";

export default function Exchanges() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/exchanges").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="Storico Cambi" subtitle="Tutti i cambi registrati" />
      {items.length === 0 ? <EmptyState icon={Repeat} title="Nessun cambio" /> : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr>
              <th className="text-left px-4 py-3">Codice</th><th className="text-left px-4 py-3">Cliente</th>
              <th className="text-left px-4 py-3">Data</th><th className="text-left px-4 py-3">Pagamento</th>
              <th className="text-right px-4 py-3">Totale</th><th className="px-4 py-3"></th></tr></thead>
            <tbody className="divide-y">
              {items.map((e) => (
                <tr key={e.id} data-testid={`exchange-${e.code}`}>
                  <td className="px-4 py-3 font-semibold text-[#0B2447]">{e.code}</td>
                  <td className="px-4 py-3 text-slate-600">{e.customer_name}</td>
                  <td className="px-4 py-3 text-slate-500">{dt(e.created_at)}</td>
                  <td className="px-4 py-3 text-slate-500">{PAYMENT_LABELS[e.payment_method]}</td>
                  <td className="px-4 py-3 text-right font-bold">{euro(e.total_cents)}</td>
                  <td className="px-4 py-3 text-right"><StatusBadge status={e.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
